export default __webpack_public_path__ + "static/media/RobotoMono-Italic-VariableFont_wght.aaba49b8.woff2";